<template>
  <div v-loading.body="loading" element-loading-text="加载中..." class="app-container">
    <store-review ref="storeReview" :store-id="storeId" :can-edit="action !== 'view'" :is-create="action === 'create'" @create="changeCreate" />
    <div class="app-form-button-height" />

    <div class="app-form-button-group">
      <el-button icon="el-icon-back" @click="onBack">返回列表</el-button>
      <el-button type="info" @click="onCreate">新增商家</el-button>
      <el-button type="primary" @click="onSubmit">提交保存</el-button>
    </div>
  </div>
</template>

<script>
import StoreReview from './review'

export default {
  name: 'StoreDetail',
  components: { StoreReview },
  data() {
    return {
      loading: false,
      action: 'create',
      storeId: ''
    }
  },
  created() {
    this.storeId = this.$route.query.id || ''
    this.action = this.$route.query.action || 'create'
  },
  methods: {
    onBack() {
      this.$router.go(-1)
    },
    onCreate() {
      this.$refs.storeReview.onCreateNew()
    },
    changeCreate() {
      this.storeId = ''
      this.action = 'create'
    },
    onSubmit() {
      this.loading = true
      this.$refs.storeReview.onSave().then(() => {
        this.$util.delay(500).then(() => {
          this.loading = false
          this.$confirm('商家数据保存成功，是否继续添加？', '温馨提示', {
            confirmButtonText: '继续添加',
            cancelButtonText: '返回列表',
            type: 'success'
          }).then(() => {
            this.onCreate()
          }).catch(() => this.$router.go(-1))
        })
      }).catch(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .app-container {
    min-height: initial;
  }
</style>
